import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import App from "./App";
import "./index.css";
import React from "react";

// Create a yellow theme
const theme = createTheme({
  palette: {
    primary: {
      main: "#FFEB3B", // yellow[500]
      light: "#FFF9C4", // yellow[100]
      dark: "#F57F17", // yellow[900]
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    secondary: {
      main: "#FDD835", // yellow[600]
      dark: "#F57F17", // yellow[900]
    },
    background: {
      default: "#f5f5f5",
    },
  },
  typography: {
    fontFamily: [
      '"Inter"',
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 6,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

// Create a default MUI theme (customize it if needed)

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <HashRouter>
        <App />
      </HashRouter>
    </ThemeProvider>
  </React.StrictMode>
);
